class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleTriggerKeydown = this.handleTriggerKeydown.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)

      if (triggerEl.tagName !== 'BUTTON') {
        this.listeners.add(triggerEl, 'keydown', this.handleTriggerKeydown)
      }
    })
  }

  handleTriggerKeydown (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return

    event.preventDefault()
    event.currentTarget.click()
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    const triggerEl = event.currentTarget

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    const nextState = !currentState

    itemEl.setAttribute('aria-expanded', nextState)
    triggerEl.setAttribute('aria-expanded', nextState)
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
